import { render, staticRenderFns } from "./membershipChargeResult.vue?vue&type=template&id=54735ad4&scoped=true&"
import script from "./membershipChargeResult.vue?vue&type=script&lang=js&"
export * from "./membershipChargeResult.vue?vue&type=script&lang=js&"
import style0 from "./membershipChargeResult.vue?vue&type=style&index=0&id=54735ad4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54735ad4",
  null
  
)

export default component.exports